<template lang="pug">
    el-dialog(title="添加队员",:fullscreen="false",:visible.sync="visible" width="80%" :append-to-body='true' :modal-append-to-body='false' @close="closeForm()")
        el-row(v-if='visible')
            el-col(:span="12")
                el-card(shadow="never")
                    div(slot="header")
                        el-row
                            el-col(:span='22')
                                el-input(v-model='memberName' clearable='', style='width:80%;' placeholder="请输入姓名/级别/手机号码")
                            el-col(:span='2')
                                el-button(@click="sizeChangeHandle" style='float:right;' icon='el-icon-search') 查询
                    div
                        el-table(ref="leftData" row-key="id"  :data="leftData" border v-el-table-infinite-scroll="currentChangeHandleLeftMember" @selection-change="checkLeftMemberAll" max-height="300" )
                            el-table-column(prop="name" label="姓名" align='center')
                            el-table-column(prop="gender" label="性别" align='center' )
                                template(slot-scope="scope")
                                    font(v-if="scope.row.gender === 0") 男
                                    font(v-if="scope.row.gender === 1") 女
                            el-table-column(prop="level" label="级别" align='center' )
                            el-table-column(prop="mobile" label="手机号码" align='center' )
                            el-table-column(type="selection" align='center' reserve-selection=true)
            el-col(:span="12")
                el-card(shadow="never")
                    div(slot="header")
                        font.font_label 已选择的人员
                    div
                        el-table(:data="rightData" border max-height="317")
                            el-table-column(prop="name" label="姓名" align='center')
                            el-table-column(prop="gender" label="性别" align='center' )
                                template(slot-scope="scope")
                                    font(v-if="scope.row.gender === 0") 男
                                    font(v-if="scope.row.gender === 1") 女
                            el-table-column(prop="level" label="级别" align='center' )
                            el-table-column(prop="mobile" label="手机号码" align='center' )
                            el-table-column(fixed="right" label="操作" align='center')
                                template(slot-scope="scope")
                                    i(class="el-icon-error" style='color:#f56c6c;cursor:pointer;font-size: 18px;' @click.prevent="deleteRowLeftMember(scope.$index, rightData)")
                                    //- el-button( @click.native.prevent="deleteRowLeftMember(scope.$index, rightData)" type="text" size="small") 移除
        span.dialog-footer(slot="footer")
            el-button(@click="addEnrollClubMember" type="primary") 确 定
            el-button(@click="visible=false") 取 消
</template>
<script>
export default {
  data () {
    return {
        visible: false,
        memberName: '',
        leftData: [], //添加队员左侧列表
        rightData: [], //添加队员右侧列表
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        selectEnrollData: {},
        enrollMember: {},
        rightDataEnroll: [], //当前俱乐部已参赛队员
        ruleForm: {}
    }
  },
  methods: {
    openFullScreen () {
        this.loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        })
    },
    //添加队员
    init (row, ruleForm) {
        this.visible = true
        if (ruleForm) {
            this.ruleForm = ruleForm
        }
        this.memberName = ''
        this.selectEnrollData = row
        this.enrollMember = {}
        this.enrollMember.ctId = this.ruleForm.id
        this.enrollMember.id = this.selectEnrollData.id
        this.leftData = []
        this.rightData = []
        this.rightDataEnroll = []
        this.pageIndex = 1
        this.getLeftData()
    },
    getLeftData () {
        console.log('添加队员页码：', this.pageIndex, this.totalPage)
        this.$http({
            url: this.$http.adornUrl(`/mbMember/getClubMbListByCbId`),
            method: 'GET',
            params: this.$http.adornParams({
                'page': this.pageIndex,
                'rows': this.pageSize,
                'cbId': this.selectEnrollData.participantInfoId,
                'name': this.memberName
            })
        }).then(data => {
            console.log('俱乐部的会员列表：', data)
            if (data && data.code === 0) {
                if (this.pageIndex === 1) {
                    this.leftData = data.page.rows
                } else {
                    this.leftData = this.leftData.concat(data.page.rows)
                }
                this.totalPage = data.page.total
                //查询俱乐部已报名队员
                this.$http({
                    url: this.$http.adornUrl(`/mbMember/getEnrollClubMemberList`),
                    method: 'GET',
                    params: this.$http.adornParams({
                        'enrollId': this.selectEnrollData.id
                    })
                }).then(data => {
                    console.log('俱乐部已报名队员；', data)
                    if (data && data.code === 0) {
                        if (data.list && data.list.length > 0) {
                            let arr = data.list.filter(item => {
                                return item.teamLeader != 1
                            })
                            console.log(arr)
                            this.rightData = arr
                            this.rightDataEnroll = arr
                            arr.forEach(e => {
                                this.leftData.forEach(b => {
                                    if (e.id === b.id) {
                                        // this.rightData.push(b)
                                        this.$refs.leftData.toggleRowSelection(b, true)
                                    }
                                })
                            })
                            console.log('右侧报名选中人员：', this.rightData)
                            console.log('右侧报名选中人员1：', this.rightDataEnroll)
                        }
                    }
                })
            } else {
                this.leftData = []
                this.totalPage = 0
            }
        })
    },
    //选中添加队员左侧列表
    checkLeftMemberAll (val) {
        this.rightData = val
    },

    // 每页数
    sizeChangeHandle (val) {
        this.pageSize = 10
        this.pageIndex = 1
        this.getLeftData()
    },
    // 当前页
    currentChangeHandleLeftMember (val) {
        console.log('触底事件：', this.pageIndex, Math.ceil(this.totalPage / this.pageSize))
        let flag = true
        if (this.pageIndex) {
            if (this.pageIndex < Math.ceil(this.totalPage / this.pageSize)) {
                this.pageIndex++
            } else {
                flag = false
            }
        } else {
            this.pageIndex = 1
        }
        if (flag) {
            this.getLeftData()
        }
    },
    deleteRowLeftMember (index, rows) {
        console.log('要删除的会员1：', index, rows, this.leftData)
        this.$refs.leftData.toggleRowSelection(rows[index], false)
        console.log('要删除的会员2：', index, rows, this.leftData)
        rows.splice(index, 1)
        console.log('要删除的会员3：', index, rows, this.leftData)
    },

    //添加俱乐部参赛会员
    addEnrollClubMember () {
        if (this.rightData.length === 0) {
            this.$message.error('请选择要添加的人员!')
        } else if (this.rightData.length > 0) {
            console.log('要提交的队员信息：', this.rightData)
            //新添加的队员
            let newList = []
            this.rightData.forEach(e => {
                //标记新添加的
                let newFlag = true
                this.rightDataEnroll.forEach(b => {
                    if (e.id === b.id) {
                        newFlag = false
                    }
                })
                if (newFlag) {
                    newList.push(e)
                }
            })

            //此次删除的队员
            let deleteList = []
            console.log('报名人员：', this.rightDataEnroll)
            this.rightDataEnroll.forEach(e => {
                //标记新添加的
                let deleteFlag = true
                this.rightData.forEach(b => {
                    if (e.id === b.id) {
                        console.log('报名人员相同：', e.id, b.id)
                        deleteFlag = false
                    }
                })
                if (deleteFlag) {
                    console.log('删除的报名人员e：', e.id)
                    deleteList.push(e)
                    console.log('删除的报名人员2：', deleteList)
                }
            })
            console.log('删除的报名人员1：', deleteList)
            if (newList.length === 0 && deleteList.length === 0) {
                this.$message.error('没有要添加或删除的人员!')
                return
            }

            this.enrollMember.ctId = this.ruleForm.id
            this.enrollMember.mbMemberList = this.rightData
            let mbIds = []
            newList.forEach(e => {
                mbIds.push(e.id)
            })
            let totalMbIds = []
            this.rightData.forEach(e => {
                totalMbIds.push(e.id)
            })

            this.$http({
                url: this.$http.adornUrl(`/elEnroll/checkMemberByMbIds`),
                method: 'GET',
                params: this.$http.adornParams({
                    'ctId': this.ruleForm.id,
                    'enrollId': this.enrollMember.id,
                    'totalMbIds': totalMbIds.join(','),
                    'mbIds': mbIds.join(',')
                })
            }).then(data => {
                console.log('选择俱乐部会员的验证结果：', data)
                if (data && data.code === 0) {
                    if (!data.state) {
                        this.$message.error(data.info)
                    } else {
                        this.openFullScreen()
                        this.$http({
                            url: this.$http.adornUrl(`/elEnroll/saveEnrollClubMember`),
                            method: 'post',
                            data: this.enrollMember
                        }).then(data => {
                            console.log(data)
                            if (data && data.code === 0) {
                                if (!data.state) {
                                    this.$message.error(data.info)
                                } else {
                                    this.$message.success('操作成功!')
                                    this.visible = false
                                    this.rightData = []
                                }
                            } else {
                                this.$message.success('操作失败!')
                            }
                            this.loading.close()
                        })
                    }
                }
            })
        }
    },
    closeForm () {
        this.visible = false
    }

  }
}
</script>
